export const prepareHeaders = (headers, {getState}) => {
  return headers;
};
